import React, { Fragment, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from "react-error-boundary";

import routes from './routes';
import { AuthContext } from './contexts/auth';
import { MagazzinoContext } from 'contexts/magazzino';

import './index.css';
import { Helmet } from 'react-helmet';

const queryCache = new QueryClient({
    defaultConfig: {
        retry: 1
    },
    retry: 0
})

function fallbackRender({ error }) {
    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre style={{ color: "red" }}>{error.message}</pre>
        </div>
    );
}

function App() {

    return (
        <QueryClientProvider client={queryCache}>
            <Suspense>
                <ErrorBoundary fallbackRender={fallbackRender}>
                    <Router>
                        <AuthContext>
                            <MagazzinoContext>
                                <Routes>
                                    {routes?.map((layout, index) => {
                                        return (
                                            <Route key={index} element={<layout.layout />} >
                                                {layout.routes.map((route, indexRoute) => {
                                                    return (
                                                        <Route
                                                            key={`${index}-${indexRoute}`}
                                                            {...route}
                                                            element={
                                                                <Fragment>
                                                                    <Helmet>
                                                                        <title>{["Pupa WMS", ...route.analytics?.name || []].reverse().join(" | ")}</title>
                                                                    </Helmet>
                                                                    <route.element />
                                                                </Fragment>
                                                            }
                                                        >
                                                            {route?.routes?.map((subroute, subIndex) =>
                                                                <Route
                                                                    key={`${subIndex}-${index}-${indexRoute}`}
                                                                    {...subroute}
                                                                    element={
                                                                        <Fragment>
                                                                            <Helmet>
                                                                                <title>{["Pupa WMS", ...subroute.analytics?.name || []].reverse().join(" | ")}</title>
                                                                            </Helmet>
                                                                            <route.element />
                                                                        </Fragment>
                                                                    }
                                                                />
                                                            )}
                                                        </Route>
                                                    )
                                                })}
                                            </Route>
                                        )
                                    })}
                                </Routes>
                            </MagazzinoContext>
                        </AuthContext>
                    </Router>
                </ErrorBoundary>
            </Suspense>

            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
}

export default App;
